<template>
  <div class="flex-auto flex justify-center items-center mx-auto w-full p-6">

    <div class="bg-white rounded-lg overflow-hidden shadow-xl w-full md:w-1/2">
      <div class="bg-gray-600 text-white p-4 text-lg font-bold">
        Endre valgperiode
      </div>

      <div class="p-12">

          <form @submit.prevent="onSubmit" v-if="electionPeriod">

            <label>Navn</label>
            <div class="mt-1">
              <input class="w-full" type="text" placeholder="For eksempel 'Vår 2020'" v-model="electionPeriod.name" />
            </div>

            <div class="mt-6">
              <label>Studiesteder</label>
              <div class="mt-1">
                <div class="flex items-center" v-for="university in universities" :key="university.universityId">
                  <div class="flex items-center">
                    <a href="#" class="check" @click.prevent="toggle(university)" @keydown.space="toggle(university)">
                      <font-awesome-icon :icon="['far', isSelected(university) ? 'check-square' : 'square']" />
                    </a>
                    <div class="ml-1" :class="{ 'font-bold': isSelected(university) }">
                      {{ university.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-6">
              <label>Aktiv</label>
              <div class="mt-1">
                <button class="check" @click.prevent="electionPeriod.isActive = !electionPeriod.isActive" @keydown.space="electionPeriod.isActive = !electionPeriod.isActive">
                  <font-awesome-icon :icon="['far', electionPeriod.isActive ? 'check-square' : 'square']" />
                </button>
              </div>
            </div>

            <div class="text-center mt-12">
              <button type="submit" class="btn btn-primary mx-2">Lagre</button>
              <router-link class="btn mx-2" to="/af/valgperioder">Avbryt</router-link>
            </div>

          </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
  name: 'ap-period-create',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      electionPeriod: null,
      universities: [],
      selectedIds: []
    }
  },
  methods: {
    isSelected (university) {
      return _.findIndex(this.selectedIds, id => id === university.universityId) >= 0
    },
    toggle (university) {
      const index = _.findIndex(this.selectedIds, id => id === university.universityId)
      if (index >= 0)  {
        this.selectedIds.splice(index, 1)
      } else {
        this.selectedIds.push(university.universityId)
      }
    },
    async onSubmit () {
      const response = await api.af.updateElectionPeriod({
        electionPeriodId: this.electionPeriod.electionPeriodId,
        name: this.electionPeriod.name,
        isActive: this.electionPeriod.isActive,
        universityIds: this.selectedIds
      })
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$router.push('/af/valgperioder')
        this.$toasted.show('Valgperiode lagret!')
      }
    }
  },
  async created () {
    this.electionPeriod = await api.af.getElectionPeriod(this.id)
    this.universities = await api.af.getUniversities()
    this.selectedIds = _.map(this.electionPeriod.electionPeriodUniversities, _ => _.universityId)
  },
}
</script>
